import ResidentBioScreen from "app/screens/residents/show/BioScreen";

export default function ResidentBioPage() {
  return <ResidentBioScreen />;
}
